import { NavBar } from "components/NavBar";
import { useAuthStatus } from "helpers/useAuthStatus";
import { useMemo } from "react";
import { Redirect, Route as ReactRoute, RouteProps } from "react-router-dom";
import { getRoute, rolesPermissionsMatch, routes } from "routes";

export const Route = ({
	children,
	path,
	...props
}: RouteProps): JSX.Element => {
	const { isLoading, role } = useAuthStatus();

	const route = useMemo(() => getRoute(path), [path]);

	if (isLoading) {
		return <NavBar />;
	}

	return (
		<ReactRoute
			{...props}
			path={path}
			render={() =>
				rolesPermissionsMatch(role, route?.permissions) ? (
					children
				) : (
					<Redirect to={routes.path} />
				)
			}
		/>
	);
};
